'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoveApi = require('../lib/CoveApi');

var _CoveApi2 = _interopRequireDefault(_CoveApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Feeback API
 */
var Feedback = function (_CoveAPI) {
  (0, _inherits3.default)(Feedback, _CoveAPI);

  /**
   * Creates a new Feedback API Client
   * @param {string} host
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function Feedback(host, environment, auth) {
    (0, _classCallCheck3.default)(this, Feedback);
    return (0, _possibleConstructorReturn3.default)(this, (Feedback.__proto__ || (0, _getPrototypeOf2.default)(Feedback)).call(this, host, 'feedback/v1', environment, auth));
  }

  /**
   * Submits feedback
   * @param {string} customer_id
   * @param {string} type one of [purchase-feedback, missing-motor, missing-item]
   * @param {{message, *}} feedbackInfo data to submit as feedback, message is the main one, also rating on purchase-feedback
   */


  (0, _createClass3.default)(Feedback, [{
    key: 'send',
    value: function send(customer, type, feedbackInfo) {
      var body = (0, _assign2.default)(feedbackInfo, { customer: customer, type: type });
      return this.apiClient.fetch('POST', 'send', null, body);
    }
  }]);
  return Feedback;
}(_CoveApi2.default);

exports.default = Feedback;